var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataCircle",style:(_vm.myStyle)},[_c('div',{style:(_vm.valueStyle)},[_c('span',{staticClass:"valueRow",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.value))])]),_c('div',{style:(_vm.labelStyle)},[_c('span',{staticClass:"labelRow"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }